module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/f9d3526e16c680095b5cf8543ac3d96e.png";